import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import moment from "moment";

const RecentEvents = ({ leadsStats }) => {
  const recentEvents = leadsStats?.recentEvents || [];

  const getEventIcon = (eventType, channel) => {
    if (eventType.includes("email.opened") || eventType === "email.opened") {
      return "ri-mail-open-line text-success";
    } else if (eventType.includes("email.clicked") || eventType === "email.clicked" || eventType === "link.clicked") {
      return "ri-links-line text-info";
    } else if (eventType.includes("email.sent") || eventType === "email.sent" || eventType === "email.delivered") {
      return "ri-mail-send-line text-primary";
    } else if (channel === "whatsapp") {
      return "ri-whatsapp-line text-success";
    } else if (channel === "sms") {
      return "ri-message-line text-info";
    } else {
      return "ri-notification-line text-secondary";
    }
  };

  const getEventLabel = (eventType, channel) => {
    if (eventType.includes("email.opened")) return "Email abierto";
    if (eventType.includes("email.clicked") || eventType === "link.clicked") return "Link clickeado";
    if (eventType.includes("email.sent") || eventType === "email.delivered") return "Email enviado";
    if (channel === "whatsapp") return "WhatsApp enviado";
    if (channel === "sms") return "SMS enviado";
    return eventType || "Evento";
  };

  return (
    <React.Fragment>
      <Col lg={6}>
        <Card>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h4 className="card-title mb-0">Últimos Eventos</h4>
              <span className="badge bg-info-subtle text-info">
                {recentEvents.length}
              </span>
            </div>

            <div className="activity-feed" style={{ maxHeight: "400px", overflowY: "auto" }}>
              {recentEvents.length === 0 ? (
                <div className="text-center text-muted py-4">
                  No hay eventos recientes
                </div>
              ) : (
                recentEvents.map((event, key) => (
                  <div key={key} className="d-flex align-items-start mb-3 pb-3 border-bottom">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-xs">
                        <span className="avatar-title rounded-circle bg-light">
                          <i className={`${getEventIcon(event.eventType, event.channel)} font-size-14`}></i>
                        </span>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h6 className="mb-1" style={{ fontSize: "13px" }}>
                            {event.contactName}
                          </h6>
                          <p className="text-muted mb-0" style={{ fontSize: "12px" }}>
                            {getEventLabel(event.eventType, event.channel)}
                          </p>
                        </div>
                        <span className="text-muted" style={{ fontSize: "11px", whiteSpace: "nowrap" }}>
                          {event.timestamp
                            ? moment(event.timestamp).fromNow()
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default RecentEvents;

